//auth
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const GET_USER = "GET_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOG_OUT = "LOG_OUT";

export const BTN_LOADING = "BTN_LOADING";

//Alerts
export const SHOW_ALERT = "SHOW_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const CLEAR_AUTH = "CLEAR_AUTH";

//College
export const ADD_COLLEGE = "ADD_COLLEGE"; //CREATE
export const GET_COLLEGES = "GET_COLLEGES"; //READ
export const UPDATE_COLLEGE = "UPDATE_COLLEGE"; //UPDATE
export const DELETE_COLLEGE = "DELETE_COLLEGE"; //DELETE

export const COLLEGE_SUCCESS = "COLLEGE_SUCCESS";
export const COLLEGE_UPDATE_SUCCESS = "COLLEGE_UPDATE_SUCCESS";
export const COLLEGE_ERROR = "COLLEGE_ERROR";
export const FILTER_COLLEGE = "FILTER_COLLEGE";

//college adding process
export const CURRENT_COLLEGE = "CURRENT_COLLEGE";
export const SELECTED_COLLEGE = "SELECTED_COLLEGE"; // after current college
export const SELECTEDCOLLEGE_DELETE = "SELECTEDCOLLEGE_DELETE"; // selecting for delete
export const CLEAN_SELECTIONS = "CLEAN_SELECTIONS"; // CLEAN SELECTION

//Courses
export const ADD_COURSE = "ADD_COURSE"; //CREATE
export const GET_ALL_COURSE = "GET_ALL_COURSE"; //READ ALL
export const UPDATE_COURSE = "UPDATE_COURSE"; //UPDATE
export const DELETE_COURSE = "DELETE_COURSE"; //DELETE

//course proccess
export const SELECTED_COURSE = "SELECTED_COURSE";
export const SELECTEDCOURSE_DELETE = "SELECTEDCOURSE_DELETE";
export const CLEANCOURSE_SELECTIONS = "CLEANCOURSE_SELECTIONS"; // CLEAN SELECTION

export const IS_ADDED = "IS_ADDED"; //DELETE
export const COURSE_SUCCESS = "COURSE_SUCCESS";
export const COURSE_UPDATE_SUCCESS = "COURSE_UPDATE_SUCCESS";
export const COURSE_ERROR = "COURSE_ERROR";
export const OPEN_MODAL_COURSES = "OPEN_MODAL_COURSES";
export const SAVE_COURSES = "SAVE_COURSES";

// Students
export const ADD_STUDENT = "ADD_STUDENT"; //CREATE
export const GET_STUDENT = "GET_STUDENT"; //READ
export const GET_STUDENT_ID = "GET_STUDENT_ID"; //READ
export const UPDATE_STUDENT = "UPDATE_STUDENT"; //UPDATE
export const DELETE_STUDENT = "DELETE_STUDENT"; //DELETE
//Student Process
export const CURRENT_STUDENT = "CURRENT_STUDENT";
export const SELECTED_STUDENT = "SELECTED_STUDENT";
export const SELECTEDSTUDENT_DELETE = "SELECTEDSTUDENT_DELETE";
export const CLEANSTUDENT_SELECTIONS = "CLEANSTUDENT_SELECTIONS";

export const STUDENT_SUCCESS = "STUDENT_SUCCESS";
export const STUDENT_UPDATE_SUCCESS = "STUDENT_UPDATE_SUCCESS";
export const STUDENT_ERROR = "STUDENT_ERROR";

// Proposals
export const GET_ALL_PROPOSALS = "GET_ALL_PROPOSALS";
export const ADD_PROPOSAL = "ADD_PROPOSAL"; //CREATE
export const GET_PROPOSAL = "GET_PROPOSAL"; //READ
export const UPDATE_PROPOSAL = "UPDATE_PROPOSAL"; //UPDATE
export const DELETE_PROPOSAL = "DELETE_PROPOSAL"; //DELETE

//Proposal Process
export const SELECTEDSTUDENT_PROPOSAL = "SELECTEDSTUDENT_PROPOSAL";
export const ADD_INTEREST = "ADD_INTEREST";
export const REMOVE_INTEREST = "REMOVE_INTEREST";
export const EDIT_INTEREST = "EDIT_INTEREST";
export const SAVING_EDIT_INTEREST = "SAVING_EDIT_INTEREST";
export const SELECTED_PROPOSAL = "SELECTED_PROPOSAL";
export const SELECTEDPROPOSAL_DELETE = "SELECTEDPROPOSAL_DELETE";
export const CLEANPROPOSAL_SELECTIONS = "CLEANPROPOSAL_SELECTIONS";

export const CLEAR_PROPOSAL = "CLEAR_PROPOSAL";

export const CREATE_LOADING = "CREATE_LOADING";

//proposal-visa
export const ADD_VISA = "ADD_VISA";
export const REMOVE_VISA = "REMOVE_VISA";
export const GET_VISA = "GET_VISA";
//proposal-insurance
export const ADD_INSURANCE = "ADD_INSURANCE";
export const REMOVE_INSURANCE = "REMOVE_INSURANCE";
export const GET_INSURANCE = "GET_INSURANCE";
export const SAVE_EDITING_INSURANCE = "SAVE_EDITING_INSURANCE";
export const CLEAR_INSURANCE_EDITION = "CLEAR_INSURANCE_EDITION";
export const EDIT_INSURANCE = "EDIT_INSURANCE";
export const EDIT_INSURANCE_PROPOSAL = "EDIT_INSURANCE_PROPOSAL";

//payment

export const MIN_PAYMENT = "MIN_PAYMENT";
export const HEALT_EXAMS = "HEALT_EXAMS";

export const types = {
  //Auth
  login: "[Auth] Login",
  logout: "[Auth] Logout",
  getUser: "[Auth] GetUser",
  //UI
  uiSetError: "[UI] Set Error",
  uiRemoveError: "[UI] Remove Error",

  uiSetLoading: "[UI] Set Loading",
  uiRemoveLoading: "[UI] Remove Loading",

  uiOpenModal: "[UI] Open modal",
  uiCloseModal: "[UI] Close modal",

  uiSetAlertModal: "[UI] Set Alert Modal modal",
  uiRemoveAlertModal: "[UI] Remove Alert Modal modal",

  //Ui-Async
  uiSetAlert: "[ALERT] Set Alert",
  uiRemoveAlert: "[ALERT] Remove Alert",

  //Colleges
  createCollege: "[COLLEGE] Create College",
  getCollege: "[COLLEGE] Get College",
  updateCollege: "[COLLEGE] Update College",
  deleteCollege: "[COLLEGE] Delete College",

  setCollegeToUpdate: "[COLLEGE] Set College To Update",
  removeCollegeFromUpdate: "[COLLEGE] Remove College From Update",

  setCollegeToDelete: "[COLLEGE] Set College To Delete",
  removeCollegeFromDelete: "[COLLEGE] Remove College From Delete",

  setCollegeInformation: "[COLLEGE] Set College Information",
  removeCollegeInformation: "[COLLEGE] Remove College Information",

  //Students
  createStudent: "[STUDENT] Create Student",
  getStudent: "[STUDENT] Get Student",
  getStudentById: "[STUDENT] Get Student By Id",
  updateStudent: "[STUDENT] Update Student",
  deleteStudent: "[STUDENT] Delete Student",

  removeStudentById: "[STUDENT] Remove Student By Id",

  setStudentToUpdate: "[STUDENT] Set Student To Update",
  removeStudentFromUpdate: "[STUDENT] Remove Student From Update",

  setStudentToDelete: "[STUDENT] Set Student To Delete",
  removeStudentFromDelete: "[STUDENT] Remove Student From Delete",

  //Courses

  createCourse: "[COURSE] Create Course",
  getCourse: "[COURSE] Get Course",
  updateCourse: "[COURSE] Update Course",
  deleteCourse: "[COURSE] Delete Course",

  setCampusFromCollege: "[COURSE] Set Course from College",
  removeCampusFromCollege: "[COURSE] Remove Course from College",

  setCourseToUpdate: "[COURSE] Set Course To Update",
  removeCourseFromUpdate: "[COURSE] Remove Course From Update",

  setCourseToDelete: "[COURSE] Set Course To Delete",
  removeCourseFromDelete: "[COURSE] Remove Course From Delete",

  //Proposals

  createProposal: "[PROPOSAL] Create Proposal",
  setProposalCreated: "[PROPOSAL] Set Proposal Created",
  removeProposalCreated: "[PROPOSAL] Remove Proposal Created",
  setProposalUpdated: "[PROPOSAL] Set Proposal Updated", //<- abre modal que contiene el link
  removeProposalUpdated: "[PROPOSAL] Remove Proposal Updated", //<- cierra modal que contiene el link

  getProposal: "[PROPOSAL] Get Proposal",
  updateProposal: "[PROPOSAL] Update Proposal",
  deleteProposal: "[PROPOSAL] Delete Proposal",

  setProposalToUpdate: "[PROPOSAL] Set Proposal to Update",
  removeProposalfromUpdate: "[PROPOSAL] Remove Proposal from Update",

  setProposalToDelete: "[PROPOSAL] Set Proposal to Delete",
  removeProposalfromDelete: "[PROPOSAL] Remove Proposal from Delete",

  setSelectedStudent: "[PROPOSAL] Set Selected Student",
  removeSelectedStudent: "[PROPOSAL] Remove Selected Student",

  setSelectedCourse: "[PROPOSAL] Set Selected Course",
  removeSelectedCourse: "[PROPOSAL] Remove Selected Course",
  setCourseToUpdateInProposal: "[PROPOSAL] Set Course Updating In Proposal", //<-setea el oobjeto en el reducer
  updateCourseSelected: "[PROPOSAL] Update Selected Courses",
  clearSelectedCourses: "[PROPOSAL] Clear Selected Courses",

  setSelectedVisa: "[PROPOSAL] Set Selected Visa",
  removeSelectedVisa: "[PROPOSAL] Remove Selected Visa",
  setVisaToUpdateInProposal: "[PROPOSAL] Set Visa Updating In Proposal", //<-SubCRUD
  updateVisaSelected: "[PROPOSAL] Update Visa Selected",
  clearSelectedVisas: "[PROPOSAL] Clear Selected Visas",

  setSelectedInsurance: "[PROPOSAL] Set Selected Insurance",
  removeSelectedInsurance: "[PROPOSAL] Remove Selected Insurance",
  setInsuranceToUpdateInProposal: "[PROPOSAL] Set Insurance Updating In Proposal",
  updateInsuranceSelected: "[PROPOSAL] Update Insurance Selected",
  clearSelectedInsurance: "[PROPOSAL] Clear Selected Insurance",

  setSelectedNote: "[PROPOSAL] Set Selected Note",
  removeSelectedNote: "[PROPOSAL] Remove Selected Note",
  setNoteToUpdateInProposal:"[PROPOSAL] Set Note Updating In Proposal",
  updateNoteSelected:"[PROPOSAL] Update Note Selected",

  setSelectedPayment: "[PROPOSAL] Set Selected Payment",
  removeSelectedPayment: "[PROPOSAL] Remove Selected Payment",

  //SideProposalActions (To open modal)
  addingStudent: "[PROPOSAL] Adding Student",
  removingStudent: "[PROPOSAL] Removing Student",

  addingCourses: "[PROPOSAL] Adding Courses",
  removingCourses: "[PROPOSAL] Removing Courses",
  updatingCourseInProposal: "[PROPOSAL] Updating Course In Proposal",
  removeUpdatingCourseInProposal: "[PROPOSAL] Removing Updating Course In Proposal",

  addingVisa: "[PROPOSAL] Adding Visa",
  removingVisa: "[PROPOSAL] Removing Visa",
  updatingVisaInProposal: "[PROPOSAL] Updating Visa In Proposal",
  removeUpdatingVisaInProposal: "[PROPOSAL] Removing Updating Visa In Proposal",

  addingInsurance: "[PROPOSAL] Adding Insurance",
  removingInsurance: "[PROPOSAL] Removing Insurance",
  updatingInsuranceInProposal: "[PROPOSAL] Updating Insurance In Proposal",
  removeupdatingInsuranceInProposal: "[PROPOSAL] Removing Updating Insurance In Proposal",

  addingNote: "[PROPOSAL] Adding Note",
  removingNote: "[PROPOSAL] Removing Note",
  updatingNoteInProposal: "[PROPOSAL] Updating Note In Proposal",
  removeUpdatingNoteInProposal: "[PROPOSAL] Removing Updating Note In Proposal",

  addingPayment: "[PROPOSAL] Adding Payment",
  removingPayment: "[PROPOSAL] Removing Payment",

  //Visa
  createVisa: "[VISA] Create Visa",
  getVisa: "[VISA] Get Visa",
};
